import {
    popupsAdobeAnalytics
} from './adobe-analytics';
import trackEidError from './eid-error-tracking';

const esim = () => {
    popupsAdobeAnalytics();
    trackEidError();
};

export default esim;
